import store from "../plugins/store";
//console.log("store.state.traductions_fr", store.state.traductions_fr);
export default {
  fr: store.state.traductions_fr,
  en: store.state.traductions_en,
  ru: store.state.traductions_ru,
  it: store.state.traductions_it,
  sp: store.state.traductions_sp
};
